import AutoBreadcrumb from "../ui/AutoBreadcrumb";
import Footer from "../ui/Footer";
import Header from "../ui/Header";

export function PublicLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden">
      <Header />
      <AutoBreadcrumb />
      <div className="p-2 sm:p-3 md:p-4 lg:p-6 min-h-[calc(100vh-200px)] bg-white">
        {children}
      </div>
      <Footer />
    </div>
  );
}
